import React, { useContext, useState, useEffect } from 'react'
import Input from 'components/forms/input'
import { RootContext } from 'context/rootContext'
import * as S from './styles'
import Button from 'src/components/button'
import useForm from './hooks/useForm'

const ResetPassword = ({
  cancelLabel,
  confirmLabel,
  dataTest,
  onCancel,
  successCallback
}) => {
  const context = useContext(RootContext)
  const { errors, watch, register, setError, submitForm } = useForm()
  const [passwordStrength, setPasswordStrength] = useState({
    hasLowerCase: false,
    hasUpperCase: false,
    hasNumber: false,
    hasMinimalCharacter: false
  })

  const checkPasswordForce = () => {
    const value = watch.newPassword
    if (!value) {
      return setPasswordStrength({
        hasLowerCase: false,
        hasUpperCase: false,
        hasNumber: false,
        hasMinimalCharacter: false
      })
    }

    const hasLowerCase = /[a-z]/.test(value)
    const hasUpperCase = /[A-Z]/.test(value)
    const hasNumber = /[0-9]/.test(value)
    const hasMinimalCharacter = value.length >= 8

    setPasswordStrength({
      hasLowerCase,
      hasUpperCase,
      hasNumber,
      hasMinimalCharacter
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await submitForm({ successCallback, context, setError })
  }

  useEffect(() => {
    checkPasswordForce()
  }, [watch.newPassword])

  return (
    <>
      <S.Form onSubmit={(e) => handleSubmit(e)}>
        <Input
          name='code'
          label='Código de acesso'
          type='text'
          placeholder='Digite o código recebido por email'
          value={watch.code}
          margin='8px auto 0 auto'
          hookForm={register('code', { required: true })}
          errorMessage={errors.code?.message}
          autoComplete='off'
          eye
        />
        <Input
          name='newPassword'
          onChange={e => checkPasswordForce(e)}
          label='Nova senha'
          type='password'
          placeholder='Digite a nova senha'
          value={watch.newPassword}
          margin='8px auto 0 auto'
          eye
          hookForm={register('newPassword', { required: true })}
          errorMessage={errors.newPassword?.message}
          autoComplete='new-password'
        />
        <Input
          name='confirmNewPassword'
          label='Confirmar senha'
          type='password'
          placeholder='Confirme a senha'
          value={watch.confirmNewPassword}
          margin='8px auto 0 auto'
          eye
          hookForm={register('confirmNewPassword', { required: true })}
          errorMessage={errors.confirmNewPassword?.message}
          autoComplete='new-password'
        />
        <S.BallContainer>
          <S.BallContent>
            <S.Ball active={passwordStrength.hasLowerCase} />
            <span>Minúscula</span>
          </S.BallContent>
          <S.BallContent>
            <S.Ball active={passwordStrength.hasUpperCase} />
            <span>Maiúscula</span>
          </S.BallContent>
          <S.BallContent>
            <S.Ball active={passwordStrength.hasNumber} />
            <span>Números</span>
          </S.BallContent>
          <S.BallContent>
            <S.Ball active={passwordStrength.hasMinimalCharacter} />
            <span>8 caracteres</span>
          </S.BallContent>
        </S.BallContainer>
        <S.Footer>
          {confirmLabel && <Button theme='primary' label={confirmLabel} type='submit' />}
          {cancelLabel && <Button theme='borderless' textDecoration='underline' margin='0 0;' label={cancelLabel} data-test={`${dataTest}-button-cancel`} onClick={() => onCancel()} />}
        </S.Footer>
      </S.Form>
    </>
  )
}

export default ResetPassword
